export var IntentType;
(function (IntentType) {
    IntentType["FAQ"] = "faq";
    IntentType["FALLBACK"] = "fallback";
})(IntentType || (IntentType = {}));
